// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__13DZP","load5":"Spinner_load5__1rIqF"};